import { getPermissions } from "../utils/secureStorage";

const LEGACY_ROLES = ["ADMIN", "CB_ADMIN", "CB_USER", "DEPTADMIN", "DCS", "CHECKER", "APPROVER", "UNION"];

const ROUTE_CONFIG = {
  FARMERMASTER: {
    ADMIN: "/admin/farmer",
    CB_ADMIN: "/master/farmermaster",
    CB_USER: "/master/farmermaster",
    DEPTADMIN: "/admin/farmer",
    DCS: "/master/farmermaster",
    CHECKER: "/checker/farmer-list",
    APPROVER: "/approver/farmer-list",
    UNION: "/union/admin/farmer-list",
    DEFAULT: "/master/farmermaster",
  },
  DCSMASTER: {
    ADMIN: "/admin/dcs",
    CB_ADMIN: "/master/dcsmaster",
    CB_USER: "/master/dcsmaster",
    DEPTADMIN: "/admin/dcs",
    DCS: "/master/dcsmaster",
    UNION: "/union/admin/dcs-list",
    DEFAULT: "/master/dcsmaster",
  },
  UNIONMASTER: {
    ADMIN: "/master/unionmaster",
    CB_ADMIN: "/master/unionmaster",
    CB_USER: "/master/unionmaster",
    DEPTADMIN: "/master/unionmaster",
    DEFAULT: "/master/unionmaster",
  },
  PLANTMASTER: {
    DEFAULT: "/master/plantmaster",
  },
  BMCMASTER: {
    DEFAULT: "/master/bmcmaster",
  },
  USERGROUPMASTER: {
    DEFAULT: "/usermasters/usergroupmaster",
  },
  USERS: {
    DEFAULT: "/master/users",
  },
  RATEMASTER: {
    DEFAULT: "/master/ratemaster",
  },
  VEHICLEMASTER: {
    DEFAULT: "/icccmaster/vehiclemaster",
  },
  DRIVERMASTER: {
    DEFAULT: "/icccmaster/drivermaster",
  },
  GPSMASTER: {
    DEFAULT: "/icccmaster/gpsmaster",
  },
  CCTVMASTER: {
    DEFAULT: "/icccmaster/cctvmaster",
  },
  SMARTLOCKS: {
    DEFAULT: "/icccmaster/smartlocks",
  },
  VEHICLEMAPPING: {
    DEFAULT: "/icccmaster/vehiclemapping",
  },
  ROUTEMASTER: {
    DEFAULT: "/icccmaster/routemaster",
  },
  MAKERREPORT: {
    DEFAULT: "/reports/makerreport",
  },
  DAILYREPORT: {
    DEFAULT: "/reports/dailyreport",
  },
  UNIONWIWSEREPORT: {
    DEFAULT: "/reports/unionwiwsereport",
  },
  MILKPROCUREMENT: {
    DCS: "/milk-procurement/farmer-list",
    UNION: "/milk-procurement/dcs-list",
    ADMIN: "/milk-procurement/dcs-list",
    APPROVER: "/milk-procurement/dcs-list",
    CHECKER: "/milk-procurement/dcs-list",
    DEPTADMIN: "/milk-procurement/dcs-list",
    CB_ADMIN: "/milk-procurement/dcs-list",
    CB_USER: "/milk-procurement/dcs-list",
  },
  DEDUCTIONS: {
    DCS: "/milkprocurement/deductions",
    CHECKER: "/milkprocurement/deductions",
    APPROVER: "/milkprocurement/deductions/dcs-list",
    UNION: "/milkprocurement/deductions/dcs-list",
    ADMIN: "/milkprocurement/deductions/dcs-list",
    DEPTADMIN: "/milkprocurement/deductions/dcs-list",
    CB_ADMIN: "/milkprocurement/deductions/dcs-list",
    CB_USER: "/milkprocurement/deductions/dcs-list",
    DEFAULT: "/milkprocurement/deductions",
  },
  MILKPROCUREMENTDAT: {
    UNION: "/union/admin/dashboard/procurement",
    DEFAULT: "/dashboard/milkprocurementdat",
  },
  DCSDAILYREPORT: {
    DCS: "/dcs/daily-report",
    ADMIN: "/reports/dcs-daily-report",
    DEFAULT: "/reports/dcs-daily-report",
  },
};

const ROUTE_TO_PROGRAM_MAP = {
  "/master/farmermaster": "FARMERMASTER",
  "/checker/farmer-list": "FARMERMASTER",
  "/approver/farmer-list": "FARMERMASTER",
  "/admin/farmer": "FARMERMASTER",
  "/union/admin/farmer-list": "FARMERMASTER",
  "/master/dcsmaster": "DCSMASTER",
  "/admin/dcs": "DCSMASTER",
  "/union/admin/dcs-list": "DCSMASTER",
  "/master/unionmaster": "UNIONMASTER",
  "/master/plantmaster": "PLANTMASTER",
  "/master/bmcmaster": "BMCMASTER",
  "/usermasters/usergroupmaster": "USERGROUPMASTER",
  "/admin/create-group": "USERGROUPMASTER",
  "/admin/edit-group": "USERGROUPMASTER",
  "/admin/create-user": "USERS",
  "/admin/edit-user": "USERS",
  "/master/users": "USERS",
  "/master/ratemaster": "RATEMASTER",
  "/icccmaster/vehiclemaster": "VEHICLEMASTER",
  "/icccmaster/drivermaster": "DRIVERMASTER",
  "/icccmaster/gpsmaster": "GPSMASTER",
  "/icccmaster/cctvmaster": "CCTVMASTER",
  "/icccmaster/smartlocks": "SMARTLOCKS",
  "/icccmaster/vehiclemapping": "VEHICLEMAPPING",
  "/icccmaster/routemaster": "ROUTEMASTER",
  "/reports/makerreport": "MAKERREPORT",
  "/reports/dailyreport": "DAILYREPORT",
  "/reports/unionwiwsereport": "UNIONWIWSEREPORT",
  "/milk-procurement/farmer-list/view-dcs/dcs-:routeDcsId": "MILKPROCUREMENT",
  "/milk-procurement/farmer-list": "MILKPROCUREMENT",
  "/milkprocurement/deductions": "DEDUCTIONS",
  "/milkprocurement/deductions/dcs-list": "DEDUCTIONS",
  "/milkprocurement/deductions/view": "DEDUCTIONS",
  "/milkprocurement/finalpayment": "MILKPROCUREMENT",
  "/milkprocurement/finalpayment/farmer-list": "MILKPROCUREMENT",
  "/milkprocurement/paymentdetails": "MILKPROCUREMENT",
  "/milkprocurement/payout": "MILKPROCUREMENT",
  "/milkprocurement/payout/farmer-list/dcs-:routeDcsId": "MILKPROCUREMENT",
  "/milkprocurement/paymentdetails/uploadpayment": "MILKPROCUREMENT",
  "/dashboard/milkprocurementdat": "MILKPROCUREMENTDAT",
  "/reports/dcs-daily-report": "DCSDAILYREPORT",
  "/dcs/daily-report": "DCSDAILYREPORT",
  "/dashboard/sappurchaseorder": "SAPPURCHASEORDER",
  "/master/sapmaterial": "SAPMATERIAL",
};

const ACTION_PRIORITY = ["APPROVE", "CHECK", "ADD", "EDIT", "DELETE", "EXPORT", "REPORT"];

export const isLegacyRole = (role) => {
  return LEGACY_ROLES.includes(role?.toUpperCase());
};

export const hasWildcardPermission = () => {
  const permissions = getPermissions();
  return permissions.some(p => p[1] === "*" && p[2] === "*");
};

export const isAdminRole = (role) => {
  const adminRoles = ["ADMIN", "CB_ADMIN", "CB_USER", "DEPTADMIN", "UNION"];
  return adminRoles.includes(role?.toUpperCase());
};

// Helper to get route based on action priority
const getRouteByAction = (config, actions) => {
  if (actions.includes("APPROVE") && config.APPROVER) return config.APPROVER;
  if (actions.includes("CHECK") && config.CHECKER) return config.CHECKER;
  return null;
};

export const getRouteForProgram = (programCode, role, entityType, actions = []) => {
  const config = ROUTE_CONFIG[programCode?.toUpperCase()];
  if (!config) return null;

  const normalizedRole = role?.toUpperCase();

  // Check admin/wildcard permissions first
  if (hasWildcardPermission() || isAdminRole(normalizedRole)) {
    return config.ADMIN || config.DEFAULT;
  }

  // Check legacy role mapping
  if (isLegacyRole(normalizedRole) && config[normalizedRole]) {
    return config[normalizedRole];
  }

  // Check entity type mapping
  if (entityType && config[entityType]) {
    return config[entityType];
  }

  // Check action-based routing
  const actionRoute = getRouteByAction(config, actions);
  if (actionRoute) return actionRoute;

  return config.DEFAULT;
};

export const getProgramCodeForRoute = (pathname) => {
  const lowerPath = pathname.toLowerCase();

  // Bypass exact program checking for nested Union view so it falls back natively to routePermissions mappings (UNION_ROLES)
  if (lowerPath.startsWith("/milk-procurement/farmer-list/view-dcs")) {
    return null;
  }

  for (const [route, program] of Object.entries(ROUTE_TO_PROGRAM_MAP)) {
    if (lowerPath.startsWith(route.toLowerCase())) {
      return program;
    }
  }

  return null;
};

export const getDashboardForUser = (role, entityType, permissions = []) => {
  const normalizedEntityType = entityType?.toUpperCase();
  const normalizedRole = role?.toUpperCase();

  // PRIMARY: entity_type determines dashboard
  switch (normalizedEntityType) {
    case "DCS":
      return "/maker/dashboard";
    case "CHECKER":
      return "/checker/dashboard";
    case "APPROVER":
      return "/approver/dashboard";
    case "UNION":
      return "/union/admin/dashboard";
    default:
      break;
  }

  // SECONDARY: Check role (for admins with no entity_type)
  if (hasWildcardPermission() || isAdminRole(normalizedRole)) {
    return "/admin/data-dashboard";
  }

  // FALLBACK: Permission-based
  const farmerPerms = permissions.filter(p => p[1] === "FARMERMASTER");
  const farmerActions = new Set(farmerPerms.map(p => p[2]));

  if (farmerActions.has("APPROVE")) return "/approver/dashboard";
  if (farmerActions.has("CHECK")) return "/checker/dashboard";
  if (farmerActions.has("ADD") || farmerActions.has("EDIT")) return "/maker/dashboard";

  return "/dashboard";
};

export { ROUTE_CONFIG, ROUTE_TO_PROGRAM_MAP, LEGACY_ROLES };
